export const BLIND_BOX_MAP = {
  1: {
    id: 1,
    title: "银色卡牌盲盒",
    cardName: "银卡",
    cardColor: "银色",
    image: require("@/assets/image/rad_card1.png"),
    minParticipants: 6,
    rewardCard: "银色卡牌",
    entryRad: 20000,
    refundRad: 20800,
  },
  2: {
    id: 2,
    title: "金色卡牌盲盒",
    cardName: "金卡",
    cardColor: "金色",
    image: require("@/assets/image/rad_card2.png"),
    minParticipants: 6,
    rewardCard: "金色卡牌",
    entryRad: 30000,
    refundRad: 31500,
  },
  3: {
    id: 3,
    title: "铜色卡牌盲盒",
    cardName: "铜卡",
    cardColor: "铜色",
    image: require("@/assets/image/rad_card3.png"),
    minParticipants: 6,
    rewardCard: "铜色卡牌",
    entryRad: 10000,
    refundRad: 10300,
  },
};

export function getBlindBoxDetail(id) {
  return BLIND_BOX_MAP[id] || null;
}
